<template>
  <div class="container-fluid">
      <b-card-text v-if="product_type.code && product_type.code=='customized'">
        <CRow>
          <CCol class="col-12 d-flex gap-4">
            <b-form-checkbox switch size="lg" v-model="is_3d_product">3D Product</b-form-checkbox>
            <b-form-checkbox switch size="lg" v-model="merge_styles">Gather all styles in frontend</b-form-checkbox>
          </CCol>
        </CRow>
      </b-card-text>
      <b-tabs pills card class="styles-tabs">
        <b-button @click="addNewStyle" class="btn-add-fields add-style-btn">Add style <span>+</span></b-button>
        <b-tab
            v-for="(style, index) in styles"
            :title="style.tab_title" :key="index"
        >
          <template v-if="styles.length > 1">
            <b-button @click="deleteStyle(index)" class="btn btn-sm">Delete style <span>-</span></b-button>
          </template>
          <CRow>
            <CCol class="col-4">
              <div>
                <label for="">Back Enabled</label>
                <b-form-checkbox
                    switch
                    v-model="style.back_enabled"
                    :key="`style_${index}_back_enabled_check_box`"
                    name="is_model_published"
                    size="lg"
                >
                </b-form-checkbox>
              </div>
            </CCol>
            <CCol class="col-8">
              <CRow>
                <CCol class="col-3 text-right">
                  Style Icon:
                </CCol>
                <CCol class="col-9" :key="`style-${style.style_icon_id}-row`">
                  <div class="image-holder flex-shrink-0" style="width:170px;position: relative;overflow: visible;" :key="`style-${style.style_icon_id}-container`"
                       :class="errors && errors.first(`fixed_logo_image_1${index}`) ? 'v-image' : ''" >
                    <template v-if="!show_style_icon_url && style.style_icon_url == '' || style.style_icon_url == null">
                      <img 
                         class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                         @click="setStyleFixedLogo(index)"
                         :key="style.style_icon_id"
                         src="../../assets/images/dummy-t.png"/>
                    </template>
                    <template v-else>
                      <img 
                         :key="style.style_icon_id"
                         :title="base_url+'/'+style.style_icon_url"
                         class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                         @click="setStyleFixedLogo(index)"
                         :src="`${base_url}/${style.style_icon_url}`" style="width:100%;height:100%"/>
                         <b-icon icon="x" class="cursor-pointer remove-icon" aria-hidden="true" style="position:absolute;top:-8px;right:-8px"
                          @click="removeStyleFixedLogo(index)"
                        >
                        </b-icon>
                    </template>  
  
                    <CInput
                        addLabelClasses="required"
                        placeholder="height"
                        type="hidden"
                        v-model="style.style_icon_url"
                        :name="`fixed_logo_image_1${index}`"
                        :id="`fixed_logo_image_1${index}`"
                    >
                    </CInput>
                  </div>
                  <div class="d-flex gap-2">
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <b-card-text>
            <CRow class="mb-5">
              <CCol class="col-12 mb-2">
                <CRow>
                  <CCol class="col-md-6">
                    <CInput
                        type="text"
                        label="Style Name"
                        addLabelClasses="required"
                        v-model="style.tab_title"
                        v-validate="'required'"
                        :name="`tab_title_${index}`"
                    ></CInput>
                  </CCol>
                  <div v-if="errors && errors.first(`tab_title_${index}`)" class="error_msg">
                   {{ errors.first(`tab_title_${index}`) }}
                  </div>
                  <CCol class="col-md-6 d-flex align-items-center">
                  <b-form-checkbox
                      v-model="style.default_style"
                      :id="'default_style_'+index"
                      name="min_default_style"
                      @change="setStyleDefault($event, index)"
                  >
                    Default
                  </b-form-checkbox>
                </CCol>
                  <div v-if="errors && errors.first(`min_default_style`)" class="error_msg">
                   {{ errors.first(`min_default_style`) }}
                  </div>
                  <div v-if="errors && errors.first(`max_default_style`)" class="error_msg">
                   {{ errors.first(`max_default_style`) }}
                  </div>
                </CRow>
  
              </CCol>
              <template v-if="product_type.code && product_type.code=='customized'">
                <template v-for="(detail_layer, detailLayerIndex) in style.detail_layers">
                  <div :style="{background: detailLayerIndex%2 == 0 && '#efefef'}" :key="`style_${index}_detail_layer_${detailLayerIndex}_row`"
                       class="w-100 rounded-lg py-2 mt-2 px-3">
                    <CRow>
                      <CCol class="col-4 mb-2">
                        <label class="required">Front detail layer {{detailLayerIndex + 1}} (.png)</label>
                        <div class="image-holder position-relative mt-2">
                          <template v-if="detail_layer.front_layer_url">
                            <img @click="openDetailLayerSelectionModal('front', index, detailLayerIndex, 'base_model')"
                                 :src="`${base_url}/${detail_layer.front_layer_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('front', index, detailLayerIndex, 'base_model')"
                                 src="../../assets/images/dummy-t.png"
                            />
                            <template v-if="detailLayerIndex == 0">
                              <input type="hidden" v-model="detail_layer.front_layer_url" v-validate="{required: true}"
                                     :name="`style_${index}_front_detail_layer_${detailLayerIndex}`">
                              <div v-if="errors && errors.first(`style_${index}_front_detail_layer_${detailLayerIndex}`)" class="error_msg">
                                {{`The style ${style.tab_title ? (style.tab_title) : ''} front detail layer ${detailLayerIndex + 1} is required`}}
                              </div>
                            </template>
                          </template>
                          <b-icon v-if="detailLayerIndex != 0 && detail_layer.front_layer_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.detail_layers[detailLayerIndex].front_layer_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
                      <CCol class="col-4 mb-2">
                        <label class="required">Back detail layer {{detailLayerIndex + 1}} (.png)</label>
                        <div class="image-holder position-relative mt-2" style="overflow: visible">
                          <img @click="openDetailLayerSelectionModal('back', index, detailLayerIndex, 'base_model')" v-if="!detail_layer.back_layer_url"
                               src="../../assets/images/dummy-t.png"
                          />
                          <img v-else  @click="openDetailLayerSelectionModal('back', index, detailLayerIndex, 'base_model')"
                               :src="`${base_url}/${detail_layer.back_layer_url}`"
                          />
                          <b-icon v-if="detail_layer.back_layer_url" icon="x" class="cursor-pointer remove-icon" aria-hidden="true"
                                  @click="style.detail_layers[detailLayerIndex].back_layer_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
                      <CCol class="col-2 mb-2 float-right" v-visible="style.detail_layers[detailLayerIndex].front_layer_url || style.detail_layers[detailLayerIndex].back_layer_url">
                        <label class="required">Select Composition</label>
                        <div class="dropdown_wrapper">
                          <v-select
                              id="product_container"
                              v-model="detail_layer.composition"
                              :options="composition_options"
                              :name="`style_${index}_layer_${detailLayerIndex}_composition`"
                              v-validate="{required: true}"
                              placeholder="Select Composition"
                          />
                        </div>
                        <div v-if="errors && errors.first(`style_${index}_layer_${detailLayerIndex}_composition`)" class="error_msg">
                          {{`The style ${style.tab_title ? (style.tab_title) : ''} composition field is required`}}
                        </div>
                      </CCol>
                      <CCol class="col-2 mb-2 float-right">
                        <div style="visibility:hidden"><label class="required">&nbsp;</label></div>
  
                        <div class="d-flex align-items-center gap-1">
                          <template v-if="detailLayerIndex == 0">
                            <b-button @click="style.detail_layers.push(getDetailLayerObject())" variant="dark">
                              <b-icon-plus />
                            </b-button>
                          </template>
                          <template v-else>
                            <b-button @click="style.detail_layers.splice(detailLayerIndex, 1)" variant="dark">
                              <b-icon-dash />
                            </b-button>
                          </template>
                          <b-button v-if="detailLayerIndex !=0" @click="swapDetailLayer('up', index, detailLayerIndex)" variant="dark">
                            <b-icon-arrow-up-short />
                          </b-button>
                          <b-button v-if="detailLayerIndex + 1 != style.detail_layers.length" variant="dark" @click="swapDetailLayer('down', index, detailLayerIndex)">
                            <b-icon-arrow-down-short />
                          </b-button>
                        </div>
                      </CCol>
                    </CRow>
                  </div>
                </template>
              </template>
              <template v-if="is_3d_product">
                <div :style="{background:'#efefef'}" class="w-100 rounded-lg py-2 mt-2 px-3">
                  <h5 class="mb-3">3D Model Configuration</h5>
                    <CRow>
                      <!-- 3D Model -->
                      <CCol class="col-2 mb-3">
                        <label class="required">3D Model (.gltf, .glb)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.three_d_model_url">
                            <div>
                              <b-icon-file-code @click="openDetailLayerSelectionModal('3d_model', index, null, '3d_model')" width="120" height="100" />
                              <label style="font-size: 10px">{{ getLastFileName(style.three_d_detail_layer.three_d_model_url) }}</label>
                            </div>
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('3d_model', index, null, '3d_model')"
                                 src="../../assets/images/dummy-t.png"
                            />
                            <input type="hidden" v-model="style.three_d_detail_layer.three_d_model_url" v-validate="{required: true}"
                                   :name="`style_${index}_3d_model`">
                            <div v-if="errors && errors.first(`style_${index}_3d_model`)" class="error_msg">
                              {{`The style ${style.tab_title ? (style.tab_title) : ''} 3d model is required`}}
                            </div>
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.three_d_model_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.three_d_model_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
  
                      <!-- Normal Map (Required) -->
                      <CCol class="col-2 mb-3">
                        <label class="required">Normal Map (.png, .jpg, .jpeg, .webp)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.three_d_texture_url">
                            <img @click="openDetailLayerSelectionModal('3d_texture', index, null, '3d_texture')"
                                 :src="`${base_url}/${style.three_d_detail_layer.three_d_texture_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('3d_texture', index, null, '3d_texture')"
                                 src="../../assets/images/dummy-t.png"
                            />
                            <input 
                              type="hidden" 
                              v-model="style.three_d_detail_layer.three_d_texture_url" 
                              v-validate="{ required: true, ext: ['png', 'jpg', 'jpeg', 'webp'] }"
                              accept=".png,.jpg,.jpeg,.webp"
                              :name="`style_${index}_3d_texture`"
                            >
                            <div v-if="errors && errors.first(`style_${index}_3d_texture`)" class="error_msg">
                              {{`The style ${style.tab_title ? (style.tab_title) : ''} base texture is required`}}
                            </div>
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.three_d_texture_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.three_d_texture_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>

                      <!-- Roughness Map -->
                      <CCol class="col-2 mb-3">
                        <label>Roughness Map (.png, .jpg, .jpeg, .webp)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.roughness_map_url">
                            <img @click="openDetailLayerSelectionModal('roughness_map', index, null, '3d_roughness')"
                                 :src="`${base_url}/${style.three_d_detail_layer.roughness_map_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('roughness_map', index, null, '3d_roughness')"
                                 src="../../assets/images/dummy-t.png"
                            />
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.roughness_map_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.roughness_map_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>

                      <!-- Metalness Map -->
                      <CCol class="col-2 mb-3">
                        <label>Metalness Map (.png, .jpg, .jpeg, .webp)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.metalness_map_url">
                            <img @click="openDetailLayerSelectionModal('metalness_map', index, null, '3d_metalness')"
                                 :src="`${base_url}/${style.three_d_detail_layer.metalness_map_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('metalness_map', index, null, '3d_metalness')"
                                 src="../../assets/images/dummy-t.png"
                            />
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.metalness_map_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.metalness_map_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
                      
                      <!-- Ambient Occlusion Map -->
                      <CCol class="col-2 mb-3">
                        <label>AO Map (.png, .jpg, .jpeg, .webp)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.ao_map_url">
                            <img @click="openDetailLayerSelectionModal('ao_map', index, null, '3d_ao')"
                                 :src="`${base_url}/${style.three_d_detail_layer.ao_map_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('ao_map', index, null, '3d_ao')"
                                 src="../../assets/images/dummy-t.png"
                            />
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.ao_map_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.ao_map_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
  
                      <!-- Alpha Map -->
                      <CCol class="col-2 mb-3">
                        <label>Alpha Map (.png, .jpg, .jpeg, .webp)</label>
                        <div class="texture-image-holder position-relative mt-2">
                          <template v-if="style.three_d_detail_layer.alpha_map_url">
                            <img @click="openDetailLayerSelectionModal('alpha_map', index, null, '3d_alpha')"
                                 :src="`${base_url}/${style.three_d_detail_layer.alpha_map_url}`"
                            />
                          </template>
                          <template v-else>
                            <img @click="openDetailLayerSelectionModal('alpha_map', index, null, '3d_alpha')"
                                 src="../../assets/images/dummy-t.png"
                            />
                          </template>
                          <b-icon v-if="style.three_d_detail_layer.alpha_map_url" icon="trash-fill" aria-hidden="true"
                                  @click="style.three_d_detail_layer.alpha_map_url = null"
                          >
                          </b-icon>
                        </div>
                      </CCol>
                      <!-- <hr :style="{color:'#efefef'}" class="w-100"/> -->
                      <template v-show="style.three_d_detail_layer.three_d_texture_url || style.three_d_detail_layer.roughness_map_url || style.three_d_detail_layer.metalness_map_url">
                        <CCol class="col-2 mb-5 gap-2">
                          <b-form-label class="font-weight-bold mb-0 text-nowrap">
                            Texture tiling for maps:
                          </b-form-label>

                          <b-form-checkbox
                            v-model="style.three_d_properties.textureTiling"
                            :key="index"
                            size="lg"
                          >
                          </b-form-checkbox>
                        </CCol>
                      </template>
                      <CCol class="col-2 mb-3 gap-2"></CCol>
                      <CCol class="col-2 mb-3 gap-2">
                        <!-- <template v-if="style.three_d_detail_layer.roughness_map_url"> -->
                          <b-form-label class="font-weight-bold"> Roughness: </b-form-label>
                          <b-form-input
                            v-model="style.three_d_properties.roughness"
                            min="0"
                            max="1"
                            step="0.01"
                            class="border border-3 rouned-md"
                            placeholder="Roughness"
                            type="number"
                            @change="validateLayerField($event, index, 'roughness', 0, 1, 0.55)"
                          ></b-form-input>
                        <!-- </template> -->
                      </CCol>
                      <CCol class="col-2 mb-3 gap-2">
                        <!-- <template v-if="style.three_d_detail_layer.metalness_map_url"> -->
                          <b-form-label class="font-weight-bold"> Metalness: </b-form-label>
                          <b-form-input
                            v-model="style.three_d_properties.metalness"
                            min="0"
                            max="1"
                            step="0.01"
                            class="border border-3 rouned-md"
                            placeholder="Metalness"
                            type="number"
                            @change="validateLayerField($event, index, 'metalness', 0, 1, 0)"
                          ></b-form-input>
                        <!-- </template> -->
                      </CCol>
                    </CRow>
                    <CRow>
                      <!-- Tile X-->
                      <CCol class="col-2 mb-3">
                        <div v-show="(style.three_d_detail_layer.three_d_texture_url || style.three_d_detail_layer.roughness_map_url || style.three_d_detail_layer.metalness_map_url) && style.three_d_properties.textureTiling">
                          <b-form-label class="font-weight-bold"> TileX: </b-form-label>
                          <b-form-input
                            v-model="style.three_d_properties.tileX"
                            :min="0"
                            :max="200"
                            :step="1"
                            class="border border-3 rouned-md"
                            placeholder="TileX"
                            type="number"
                            @change="validateLayerField($event, index, 'tileX', 0, 200, 9)"
                          ></b-form-input>
                        </div>
                      </CCol>
                      <!-- Normal X -->
                      <CCol class="col-2">
                        <b-form-label class="font-weight-bold"> Normal X: </b-form-label>
                        <b-form-input 
                          v-model="style.three_d_properties.normalScaleX" 
                          :min="0" 
                          :max="200" 
                          :step="1" 
                          class="border border-3 rouned-md" 
                          placeholder="NormalScaleX" 
                          type="number"
                          @change="validateLayerField($event, index, 'normalScaleX', 0, 1.5, 0.8)"
                        ></b-form-input>
                      </CCol>
                      <!-- Sheen -->
                      <CCol class="col-2">
                        <b-form-label name="sheen" class="font-weight-bold"> Sheen: </b-form-label>
                        <b-form-input
                          v-model="style.three_d_properties.sheen"
                          class="border border-3 rounded-md"
                          placeholder="Sheen"
                          type="number"
                          min="0" max="1" step="0.01"
                          @change="validateLayerField($event, index, 'sheen', 0, 3, 1)"
                        ></b-form-input>
                      </CCol>
                      <!-- Sheen Roughness -->
                      <CCol class="col-2">
                        <b-form-label class="font-weight-bold"> Sheen Roughness: </b-form-label>
                        <b-form-input
                          v-model="style.three_d_properties.sheenRoughness"
                          min="0"
                          max="1"
                          step="0.01"
                          class="border border-3 rouned-md"
                          placeholder="Sheen Roughness"
                          type="number"
                          @change="validateLayerField($event, index, 'sheenRoughness', 0, 1, 0.4)"
                        ></b-form-input>
                      </CCol>
                      <!-- Sheen Color -->
                      <CCol class="col-2">
                        <b-form-label class="font-weight-bold"> Sheen Color: </b-form-label>
                        <b-form-input v-model="style.three_d_properties.sheenColor" class="border border-3 rouned-md mb-2" placeholder="Reflectivity" type="text" pattern="^#[0-9A-Fa-f]{0,6}$"></b-form-input>
                        <b-form-input type="color" id="color-picker" v-model="style.three_d_properties.sheenColor"></b-form-input>
                      </CCol>
                      <!-- Inside Material Color -->
                      <CCol class="col-2">
                        <b-form-label class="font-weight-bold"> Inside Material Color: </b-form-label>
                        <b-form-input v-model="style.three_d_properties.insideMaterialColor" class="border border-3 rouned-md mb-2" placeholder="Inside Material Color" type="text" pattern="^#[0-9A-Fa-f]{0,6}$"></b-form-input>
                        <b-form-input type="color" id="color-picker" v-model="style.three_d_properties.insideMaterialColor"></b-form-input>
                      </CCol>
                    </CRow>
                    <CRow>
                      <!-- Tile Y -->
                      <CCol class="col-2 mb-3">
                        <div v-show="(style.three_d_detail_layer.three_d_texture_url || style.three_d_detail_layer.roughness_map_url || style.three_d_detail_layer.metalness_map_url) && style.three_d_properties.textureTiling">
                          <b-form-label class="font-weight-bold"> TileY: </b-form-label>
                          <b-form-input
                            v-model="style.three_d_properties.tileY"
                            :min="0"
                            :max="200"
                            :step="1"
                            class="border border-3 rouned-md"
                            placeholder="TileY"
                            type="number"
                            @change="validateLayerField($event, index, 'tileY', 0, 200, 9)"
                          ></b-form-input>
                        </div>
                      </CCol>
                      <!-- Normal Y -->
                      <CCol class="col-2 mb-3">
                        <b-form-label class="font-weight-bold"> Normal Y: </b-form-label>
                        <b-form-input 
                          v-model="style.three_d_properties.normalScaleY" 
                          :min="0" 
                          :max="200" 
                          :step="1" 
                          class="border border-3 rouned-md" 
                          placeholder="NormalScaleY" 
                          type="number"
                          @change="validateLayerField($event, index, 'normalScaleY', 0, 1.5, 0.8)"
                        ></b-form-input>
                      </CCol>
                      <!-- Reflectivity -->
                      <CCol class="col-2 mb-3">
                        <b-form-label class="font-weight-bold"> Reflectivity: </b-form-label>
                        <b-form-input
                          v-model="style.three_d_properties.reflectivity"
                          min="0"
                          max="1"
                          step="0.01"
                          class="border border-3 rouned-md"
                          placeholder="Reflectivity"
                          type="number"
                          @change="validateLayerField($event, index, 'reflectivity', 0, 1, 0.35)"
                        ></b-form-input>
                      </CCol>
                    </CRow>
                  </div>
              </template>
            </CRow>
            <CRow class="mb-5">
              <CCol class="col-4 mb-2 float-right">
                <label class="required">Select Container</label>
                <div class="dropdown_wrapper">
                  <v-select
                      id="product_container"
                      v-model="style.selected_container"
                      :options="containers"
                      :name="`product_container_${index}`"
                      v-validate="{required: true}"
                      placeholder="Select Container"
                      @input="getContainerDesign(index)"
                  />
                </div>
                <div v-if="errors && errors.first(`product_container_${index}`)" class="error_msg">
                  {{ errors.first(`product_container_${index}`) }}
                </div>
              </CCol>
            </CRow>
            <CRow class="mb-4">
              <CCol class="col-4">
                <label class="required">Front design (.svg)</label>
              </CCol>
              <CCol class="col-4" v-if="style.back_enabled">
                <label class="required">Back design (.svg)</label>
              </CCol>
              <CCol class="col-2">
                <label class="required">Design Name</label>
              </CCol>
              <CCol class="col-1"> <label>Published</label> </CCol>
              <CCol class="col-1">
                <label class="required">Default</label>
              </CCol>
            </CRow>
            <CRow v-for="(design, index2) in style.designs" :key="index2" class="mb-5 added-row align-items-center">
              <CCol class="col-4">
                <div class="image-holder">
                  <template v-if="(product_type.code && product_type.code=='customized')">
                    <img v-if="design.front_design_url == ''" src="../../assets/images/dummy-t.png" />
                    <span v-else :ref="'img_front'+index+''+index2">
                      <template>
                         <img :src="`${base_url}/${design.front_design_url}`" />
                      </template>
                    </span>
                  </template>
                  <template v-if="(product_type.code && product_type.code=='personalized')">
                    <img v-if="design.front_design_url == ''" src="../../assets/images/dummy-t.png" />
                    <img v-else :ref="'img_front'+index+''+index2" :src="`${base_url}/${design.front_design_url}`"/>
                  </template>
                </div>
              </CCol>
              <CCol class="col-4" v-if="style.back_enabled || (product_type.code && product_type.code=='personalized')">
                <div class="image-holder">
                  <template v-if="(product_type.code && product_type.code=='customized')">
                    <img v-if="design.back_design_url == ''" src="../../assets/images/dummy-t.png" />
                    <img v-else :src="`${base_url}/${design.back_design_url}`" />
                  </template>
                  <template v-if="(product_type.code && product_type.code=='personalized')">
                    <img v-if="design.back_design_url == ''" src="../../assets/images/dummy-t.png" />
                    <img v-else :ref="'img_back'+index+''+index2" :src="`${base_url}/${design.back_design_url}`"/>
                  </template>
                </div>
              </CCol>
              <CCol class="col-2">
                  {{ design.design_name }}
                <div v-if="errors && errors.first(`design_name_${index}${index2}`)" class="error_msg">
                  {{ errors.first(`design_name_${index}${index2}`) }}
                </div>
              </CCol>
              <CCol class="col-1">
                <div>
                  <b-form-checkbox
                      switch
                      v-model="design.is_published"
                      :id="'switch_'+index+index2"
                      :key="index+index2"
                      name="is_model_published"
                      size="lg"
                      @change="CheckIsDefault($event, index, index2)"
                  >
                  </b-form-checkbox>
                </div>
              </CCol>
              <CCol class="col-1 default-col">
                <template>
                  <div>
                    <b-form-checkbox
                        :id="'checkbox_'+index+index2"
                        v-model="design.is_default"
                        name="is_default"
                        :disabled="(style.checked_index != index+''+index2) ? style.is_default_design : false"
                        @change="CheckDefault($event, index, index2)"
                    >
                    </b-form-checkbox>
  
                  </div>
                </template>
              </CCol>
            </CRow>
          </b-card-text>
        </b-tab>
  
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div>
            <b-button title="Previous step" @click="basicTab" class="light" variant="primary"><BIconArrowLeft /></b-button>
          </div>
          <div class="d-flex gap-2">
            <b-button @click="GoToCustomizeJourney(0)" variant="primary">Save and close</b-button>
            <b-button @click="GoToCustomizeJourney(2)" variant="primary">Save and Stay</b-button>
          </div>
          <div>
            <b-button title="Next step" class="light" @click="GoToCustomizeJourney(1)" variant="primary"><BIconArrowRight /></b-button>
          </div>
        </div>
      </b-tabs>
      <b-modal id="assetSelectorFrontDesign" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
          <span>File Manager</span>
        </template>
        <asset-selector :selectedImage="setStyleFrontDesignModel" :factory_id="factory_id"  :fileType="'texture'"></asset-selector>
      </b-modal>
  
      <b-modal id="assetSelectorBackDesign" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
          <span>File Manager</span>
        </template>
        <asset-selector :selectedImage="setStyleBackDesignModel" :factory_id="factory_id" :fileType="'texture'"></asset-selector>
      </b-modal>
  
      <b-modal id="secondDetailLayerModal" size="lg" no-close-on-backdrop  hide-footer @hide="setActiveDetailLayerInfo()">
        <template #modal-title>
          <span>Select map</span>
        </template>
        <asset-selector :selectedImage="handleDetailLayersSelection" :factory_id="factory_id" :fileType="this.active_detail_layer_info.file_type"></asset-selector>
      </b-modal>
  
      <b-modal id="setStyleFixedLogo" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
          <span>Style Icons</span>
        </template>
        <!--          <ValidationProvider rules="required" v-slot="{ errors }">-->
        <asset-selector :fileType="'style_icon'" @onselectimage="addStyleFixedLogo" :factory="true" :factory_id="factory_id"></asset-selector>
        <!--          </ValidationProvider>-->
  
      </b-modal>
  </div>
  </template>
  <script>
  import { getCompositionsOptions } from "@/helpers/Helpers";
import { CCol } from "@coreui/vue";
import Vue from 'vue';
  
  export default {
    props: {
      product_type: Object,
      product_id: Number,
      factory_id: Number,
      svgGroups: Array
    },
    async created() {
      this.setActiveDetailLayerInfo()
      try {
        this.$store.commit('set', ['showLoader', true]);
        let params = this.role_name === "factory" ? `?product_id=${this.product_id}&factory_id=${this.factory_id}` : '';
        let res = await this.$store.dispatch('getAllContainer', params);
        let data = res.data.data;
        for (let cc=0; cc<data.length; cc++){
          if(data[cc].files.length > 0){
            this.containers.push({
              id: data[cc].id,
              label: data[cc].name,
            });
          }
        }
        this.$store.commit('set', ['showLoader', false]);
  
  
        if(this.$route.params.id){
          this.$store.commit('set', ['showLoader', true]);
          let res = await this.$store.dispatch('getStyles', this.$route.params.id);
  
          let styles = res.data.data;
          this.is_3d_product = res.data.product.is_3d_product ==  1 ? true : false ;
          this.merge_styles = res.data.product.merge_styles == 1 ? true : false ;
          this.$emit('set-product-id', res.data.product.id);
          if(styles.length > 0){
            this.styles = [];
            for (let index = 0; index < styles.length; index++){
              let style = styles[index];
              const style_data = {
                id:style.id, 
                back_enabled:style.back_enabled, 
                tab_title: style.name, 
                default_style: style.default_style === 0 ? false: true, 
                detail_layers: await this.formatStyleDetailLayers(style), 
                three_d_detail_layer: await this.format3DStyleDetailLayers(style), 
                three_d_properties: this.format3DProperties(style) 
              }
              this.styles.push(this.getStyleDefaultObject(style_data))
              let designs = [];
              for(let count=0; count<style.productdesigns.length; count++){
                let design = style.productdesigns[count];
                if(design.is_default == 1 && !this.styles[index].is_default_design){
                  this.styles[index].is_default_design = true;
                }
                if(design.is_default == 1){
                  this.styles[index].checked_index = index+''+count;
                }
                this.styles[index].selected_container = this.containers.find(elem => design.front_design && elem.id == design.front_design.container_id);
                //New Url Added
                this.styles[index].style_icon_id = style.style_icon?style.style_icon.id: null;
                this.styles[index].style_icon_url = style.style_icon?style.style_icon.file_url:null;
                //New Url Added
  
                if((this.product_type.code == 'customized' && design.front_design && design.front_design.file_extension == 'svg')
                || (this.product_type.code == 'personalized' && design.front_design && design.front_design.file_extension != 'svg')){
                  designs.push({
                    front_design: design.front_design_id,
                    front_design_url: design.front_design.file_url,
                    back_design: design.back_design_id,
                    back_design_url: (design.back_design) ? design.back_design.file_url : '',
                    design_name: design.design_name,
                    container_file_id: design.container_file_id,
                    production_design: design.production_design_id,
                    frontsafezone_design: design.frontsafezone_design_id,
                    backsafezone_design: design.backsafezone_design_id,
                    productionsafezone_design: design.productionsafezone_design_id,
                    frontboundary_design: design.frontboundary_design_id,
                    backboundary_design: design.backboundary_design_id,
                    is_published: (design.is_active == 1) ? true : false,
                    is_default: (design.is_default == 1) ? true : false,
                  });
                }
  
              }
  
              Vue.set(this.styles[index], 'designs', designs)
  
              let logos = [];
              if(style.logo.length < 1){
                logos.push({
                  x_axis: '',
                  y_axis: '',
                  rotation: '',
                  logo_url: '',
                  width: '',
                  height: '',
                  file_id: '',
                  side: {id: 'front', label: 'Front'}
                });
              }else{
                for (let i=0; i<style.logo.length; i++){
                  let logo = style.logo[i];
                  let logo_side = null;
                  if(logo.side == 'front'){
                    logo_side = {
                      label: 'Front',
                      id: 'front'
                    }
                  }else{
                    logo_side = {
                      label: 'Back',
                      id: 'back'
                    }
                  }
                  logos.push({
                    x_axis: logo.x_axis,
                    y_axis: logo.y_axis,
                    rotation: logo.rotation,
                    logo_url: logo.file.file_url,
                    width: logo.width,
                    height: logo.height,
                    file_id: logo.file_id,
                    side: logo_side,
                  });
                }
              }
  
  
              Vue.set(this.styles[index], 'fixed_logos', logos)
            }
            this.$nextTick(this.$forceUpdate);
          } else {
            this.styles.push(this.getStyleDefaultObject())
          }
  
          this.$store.commit('set', ['showLoader', false]);
          this.$emit('product_styles', this.styles);
          
          for (let si = 0; si < this.styles.length; si++) {
            if (this.styles[si].selected_container) {              
              // getContainerDesign will parse server svg_parts and emit svgGroups
              // await to process one style at a time
              // eslint-disable-next-line no-await-in-loop
              await this.getContainerDesign(si);
            }
          }

          if(res.data.product.step_completed == 2){
            this.$emit('set-tab-index', 2, 'next');
          }
        }
  
        this.addFieldValidationRules();
  
      }catch (err){
        this.$store.commit('set', ['showLoader', false]);
        this.showError(err);
      }
    },
    computed: {
      svg_group_color_container() {
        return this.$store.getters.getJourney.svg_group_color_container
      }
    },
    data(){
      return {
        selectedColor: '#b3b3b3',
        is_3d_product:false,
        merge_styles: false,
        style_index: '',
        design_index: '',
        containers: [],
        limit: [],
        styles:[],
        fields: [],
        base_url: process.env.VUE_APP_FILE_URL,
        fields_error_messages: {
          custom: {}
        },
        select: { state: 'Florida', abbr: 'FL' },
        items: [
          { state: 'Florida', abbr: 'FL' },
          { state: 'Georgia', abbr: 'GA' },
          { state: 'Nebraska', abbr: 'NE' },
          { state: 'California', abbr: 'CA' },
          { state: 'New York', abbr: 'NY' },
        ],
        active_detail_layer_info: {},
        composition_options: getCompositionsOptions(),
        show_style_icon_url:false,
        roughness: 0,
        metalness: 0,
      }
    },
    methods:{
      validateLayerField(value, index, field, min = 0, max = 1, defaultValue = 0) {
        let num = parseFloat(String(value).replace(/[^0-9.]/g, ''));

        if (isNaN(num)) num = defaultValue;

        num = Math.min(Math.max(num, min), max);
        this.$set(this.styles[index].three_d_properties, field, num);
      },
       parseServerSvgParts(partsField) {
        if (!partsField) return [];
        try {
          if (Array.isArray(partsField)) return partsField.map(p => typeof p === 'string' ? p.toLowerCase() : p);
          if (typeof partsField === 'string') {
            const trimmed = partsField.trim();
            if (trimmed.startsWith('[')) {
              const parsed = JSON.parse(trimmed);
              return Array.isArray(parsed) ? parsed.map(p => typeof p === 'string' ? p.toLowerCase() : p) : [];
            }
            return trimmed.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
          }
        } catch (e) {
          return [];
        }
        return [];
    },
    // emit groups preserving prior shape; avoid duplicate emits using containsObject()
      emitSvgGroupsForParts(parts = []) {
        (parts || []).forEach(rawId => {
          if (!rawId) return;
          const id = typeof rawId === 'string' ? rawId.toLowerCase() : rawId;          
          if (
            !id.includes('noncustomizable') &&
            !id.includes('inside') &&
            !this.containsObject({ id })
          ) {
            let color_container_id = '';
          if (this.svg_group_color_container) {
              const g = this.svg_group_color_container.find(sg => sg.id === id);
              if (g) color_container_id = g.color_container_id;
            }
            this.$emit('updateSvgGroups', { id, color_container_id });
          }
        });
      },      
      containsObject(obj) {
        const id = typeof obj.id === 'string' ? obj.id.toLowerCase() : obj.id;
        for (let i = 0; i < this.svgGroups.length; i++) {
          if (this.svgGroups[i].id.toLowerCase() === id) {
            return true;
          }
        }
        return false;
      },
     async getContainerDesign(style_index) {        
        try {
          if (!this.styles[style_index].selected_container) {
            Vue.set(this.styles[style_index], 'designs', []);
            this.addFieldValidationRules();
            return;
          }

          this.$store.commit('set', ['showLoader', true]);
          const res = await this.$store.dispatch('getContainerDesigns', this.styles[style_index].selected_container.id);
          const designs = (res && res.data && res.data.data) ? res.data.data : [];

          // PRESERVE existing design defaults from the initial load
          const existingDesigns = this.styles[style_index].designs || [];
          
          Vue.set(this.styles[style_index], 'designs', []);
          this.limit = [];
          
          const finalDesigns = [];
          
          for (let i = 0; i < designs.length; i++) {
            const sd = designs[i];

            const isFrontRelevant =
              (this.product_type.code === 'customized' && sd.front && sd.front.file_extension === 'svg') ||
              (this.product_type.code === 'personalized' && sd.front && sd.front.file_extension !== 'svg');

            if (!isFrontRelevant) continue;

            // tolerant read of server-provided parts (svg_parts may be JSON-string or array)
            const frontRaw = (sd.front && (sd.front.svg_parts || sd.front.parts || sd.front.part_ids || sd.front.extracted_parts)) || sd.front_parts || [];
            const backRaw  = (sd.back  && (sd.back.svg_parts  || sd.back.parts  || sd.back.part_ids  || sd.back.extracted_parts))  || sd.back_parts  || [];

            const normalizedFront = this.parseServerSvgParts(frontRaw);
            const normalizedBack  = this.parseServerSvgParts(backRaw);

            // Find if this design exists in the initial load and preserve its is_default value
            const existingDesign = existingDesigns.find(ed => 
              ed.front_design === (sd.front ? sd.front.id : "") &&
              ed.back_design === (sd.back ? sd.back.id : "")
            );

            finalDesigns.push({
              front_design: (sd.front) ? sd.front.id : "",
              front_design_url: (sd.front) ? sd.front.file_url : "",
              back_design: (sd.back) ? sd.back.id : "",
              back_design_url: (sd.back) ? sd.back.file_url : "",
              design_name: sd.front ? sd.front.design_name : "",
              container_file_id: sd.front ? sd.front.file_id : "",
              production_design: sd.production ? sd.production.id : "",
              frontsafezone_design: sd.frontsafezone ? sd.frontsafezone.id : "",
              backsafezone_design: sd.backsafezone ? sd.backsafezone.id : "",
              productionsafezone_design: sd.productionsafezone ? sd.productionsafezone.id : "",
              frontboundary_design: sd.frontboundary ? sd.frontboundary.id : "",
              backboundary_design: sd.backboundary ? sd.backboundary.id : "",
              is_published: existingDesign ? existingDesign.is_published : true,
              is_default: existingDesign ? existingDesign.is_default : false, // PRESERVE is_default
              // attach server-provided parts for the customization journey
              front_parts: normalizedFront,
              back_parts: normalizedBack
            });

            // register parts into svgGroups (preserve previous behavior)
            this.emitSvgGroupsForParts(normalizedFront);
            this.emitSvgGroupsForParts(normalizedBack);

            // keep validator behavior from previous implementation
            // eslint-disable-next-line no-await-in-loop
            await this.$nextTick();
          }

          Vue.set(this.styles[style_index], 'designs', finalDesigns);
          Vue.set(this.styles, style_index, this.styles[style_index]);
        } catch (err) {
          this.showError && this.showError(err);
        } finally {
          this.$store.commit('set', ['showLoader', false]);
          this.addFieldValidationRules();
        }
      },
      ValidateStyles(){
        let valid = true;
        let length = this.styles.length;
        let message = '';
        for (let index = 0; index < length; index++) {
            if(!this.styles[index].is_default_design){
              message = 'select 1 design as default design from ' + this.styles[index].tab_title + ' style';
              valid = false;
            }else{
              let style_name = this.styles[index].tab_title;
              if(!this.styles[index].selected_container){
                valid = false;
                message = "Design container of style '"+style_name+"' is required";
                break;
              }
            }
          }
  
        if(!valid){
          if(message != '') {
            this.showToast(message, 'DANGER');
          }
        }
        return valid;
      },
      validateStyleDefault() {
        let valid = true;
        const defaultStyle = this.styles.find(style => style.default_style === true);
        if (!defaultStyle) {
            this.showToast('No style is selected as default', 'DANGER');
            valid = false;
            return valid;
          }
        const defaultCount = this.styles.reduce((count, style) => count + (style.default_style === true ? 1 : 0), 0);
        if (defaultCount !== 1) {
          this.showToast('Only one style should be selected as default', 'DANGER');
          valid = false;
          return valid
        }
        return valid;
      },
      basicTab(){
        this.$emit('active_basic_tab', true);
      },
      async GoToCustomizeJourney(proceed){
        this.addFieldValidationRules()
        let valid = await this.$validator.validate();
        if(valid) {
          let status = await this.ValidateStyles();
          let default_style = await this.validateStyleDefault();
  
          if(status && default_style)
          {
          let styleFormData = {};
          let product_styles = [];
  
          for (let count = 0; count < this.styles.length; count++) {
            let style = this.styles[count];
            let data = {
              id: style.id,
              style_name: style.tab_title,
              back_enabled: style.back_enabled,
              default_style: style.default_style,
              style_icon_id: this.styles[count].style_icon_id,
              detail_layers_payload: await this.getDetailLayersFromStyle(style),
              three_d_properties: this.get3DPropertiesFromStyle(style)
            }
            let designs = [];
            for (let inc = 0; inc < style.designs.length; inc++) {
              designs.push({
                front_design: style.designs[inc].front_design,
                back_design: style.designs[inc].back_design,
                design_name: style.designs[inc].design_name,
                container_file_id: style.designs[inc].container_file_id,
                production_design: style.designs[inc].production_design,
                frontsafezone_design: style.designs[inc].frontsafezone_design,
                backsafezone_design: style.designs[inc].backsafezone_design,
                productionsafezone_design: style.designs[inc].productionsafezone_design,
                frontboundary_design: style.designs[inc].frontboundary_design,
                backboundary_design: style.designs[inc].backboundary_design,
                is_active: style.designs[inc].is_published,
                is_default: style.designs[inc].is_default,
              })
            }
            data.design = designs;
  
            product_styles.push(data);
          }
  
          styleFormData.product_id = this.product_id;
          styleFormData.is_3d_product = this.is_3d_product ? 1 : 0;
          styleFormData.merge_styles = this.merge_styles ? 1 : 0; 
          styleFormData.product_styles = product_styles;
  
          this.$store.commit('set', ['showLoader', true]);
          let response = await this.$store.dispatch('saveProductStep2', styleFormData);
          this.$store.commit('set', ['showLoader', false]);
  
          this.$emit('set-step-completed', response.data.data.step_completed);
          let style_ids = response.data.data.styles;
          this.styles.forEach(function (style, index) {
            if (style.id == 0) {
              style.id = style_ids[index];
            }
          })
  
            if (proceed == 1) {
              await this.$emit('product_styles', this.styles);
              this.$emit('set-tab-index', 2, '');
            } else if (proceed == 2) {
              this.showToast('Product has been saved successfully','SUCCESS')
              this.$emit('product_styles', this.styles);
            } else {
              this.showToast('Product has been saved successfully','SUCCESS')
              this.$router.push('/products');
            }
  
        } else {
            this.showToast("Please fill all required fields", "error");
          }
        } else {
          this.showToast("Please fill all required fields", "error");
        }
      },
      setStyleBackDesign(style_index, design_index){
        this.style_index = style_index;
        this.design_index = design_index;
        this.$bvModal.show('assetSelectorBackDesign');
      },
      setStyleBackDesignModel(item){
        this.styles[this.style_index].designs[this.design_index].back_design = item.id;
        this.styles[this.style_index].designs[this.design_index].back_design_url = item.file_url;
        this.$bvModal.hide('assetSelectorBackDesign');
      },
      setStyleFrontDesign(style_index, design_index){
        this.style_index = style_index;
        this.design_index = design_index;
        this.$bvModal.show('assetSelectorFrontDesign');
      },
      setStyleFrontDesignModel(item){
        this.styles[this.style_index].designs[this.design_index].front_design = item.id;
        this.styles[this.style_index].designs[this.design_index].front_design_url = item.file_url;
        this.$bvModal.hide('assetSelectorFrontDesign');
      },
      ResetForm(){
        this.$bvModal.show("addFieldModel");
        this.steps = this.$store.getters.getProductSteps;
      },
      setStyleDefault(event,style_index){
        this.styles.map(style => {
          style.default_style = false;
          return style;
        })
        this.styles[style_index].default_style = event;
      },    
      CheckDefault(event, style_index,design_index){
        let index = style_index+''+design_index;
  
        this.styles[style_index].is_default_design = event;
        if(event){
          this.limit.push(event)
          this.styles[style_index].checked_index = index;
          this.styles[style_index].designs[design_index].is_published = true;
        }else{
          this.limit = [];
          this.styles[style_index].checked_index = -1;
        }
      },
      CheckIsDefault(event, style_index,design_index){
  
        if(this.styles[style_index].designs[design_index].is_default
            && this.styles[style_index].designs[design_index].is_published === false
        ){
          this.styles[style_index].designs[design_index].is_published = true;
          this.showToast('Default design cannot be Inactive', 'DANGER');
        }
  
      },
      addNewDesign(styleIndex){
        this.styles[styleIndex].designs.push({
          front_design: "",
          front_design_url: '',
          back_design: "",
          back_design_url: "",
          design_name: '',
          container_file_id: '',
          production_design:'',
          frontsafezone_design:'',
          backsafezone_design:'',
          productionsafezone_design:'',
          frontboundary_design:'',
          backboundary_design:'',
          is_published: true,
          is_default: false,
          style_icon_id:'',
          style_icon_url:'',
        })
      },
      async deleteStyle(index){
        if (this.styles[index]){
          let style = this.styles[index]
          if (confirm("you are going to remove the style") == true){
            let models = null
            if(style.id == 0) {
              this.styles.splice(index, 1)
              this.showToast("Style deleted")
              return false
            }
            let res = await this.$store.dispatch('removeProductStyle', {prd_id: this.product_id, style_id: this.styles[index].id})
            if (res.status == 204) {
              this.styles.splice(index, 1)
              this.showToast("Style deleted")
            }
          }
        }
      },
      removeDesign(styleIndex, designIndex){
        this.styles[styleIndex].designs.splice(designIndex, 1);
      },
      addNewStyle(){
        this.styles.push(this.getStyleDefaultObject());
        this.$nextTick(this.$forceUpdate);
        this.addFieldValidationRules();
      },
      addFieldValidationRules(){
        let total_styles = this.styles.length;
        for(let i=0; i < total_styles; i++){
          this.fields_error_messages.custom[`tab_title_${i}`] = {
            required: 'Style name is required'
          }
          this.fields_error_messages.custom[`product_container_${i}`] = {
            required: 'Product container is required'
          }
  
          let total_designs = this.styles[i].designs.length;
  
          for(let k=0; k < total_designs; k++){
            this.fields_error_messages.custom[`design_name_${i}${k}`] = {
              required: 'Design name is required'
            }
          }
        }
        this.$validator.localize('en', this.fields_error_messages);
      },
      clearContainerDesigns(){
  
        for(let i=0; i < this.styles.length; i++){
          this.styles[i].selected_container = null
          Vue.set(this.styles[i], 'designs', [])
        }
  
      },
      setActiveDetailLayerInfo({ type = null, style_index = null, detail_layer_index = null, file_type = null} = {}) {
        this.active_detail_layer_info = {type: type, style_index: style_index, detail_layer_index: detail_layer_index, file_type}
      },
      openDetailLayerSelectionModal(type, style_index, detail_layer_index, file_type) {
        this.setActiveDetailLayerInfo({ type: type, style_index: style_index, detail_layer_index: detail_layer_index, file_type})
        this.$bvModal.show('secondDetailLayerModal');
      },
      handleDetailLayersSelection(selected_detail_layer) {
        const {id, file_url} = selected_detail_layer
        const {type, style_index, detail_layer_index, file_type} = this.active_detail_layer_info
        if(file_type == 'base_model') {
          if(type == 'front') {
            this.styles[style_index].detail_layers[detail_layer_index].front_layer_url = file_url
            this.styles[style_index].detail_layers[detail_layer_index].front_layer_id = id
          } else {
            this.styles[style_index].detail_layers[detail_layer_index].back_layer_url = file_url
            this.styles[style_index].detail_layers[detail_layer_index].back_layer_id = id
          }
        } else if(file_type == '3d_model') {
          this.styles[style_index].three_d_detail_layer.three_d_model_url = file_url
          this.styles[style_index].three_d_detail_layer.three_d_model_id = id
        } else if(file_type == '3d_texture') {
          this.styles[style_index].three_d_detail_layer.three_d_texture_url = file_url
          this.styles[style_index].three_d_detail_layer.three_d_texture_id = id
        } else if(file_type == '3d_roughness') {
          this.styles[style_index].three_d_detail_layer.roughness_map_url = file_url
          this.styles[style_index].three_d_detail_layer.roughness_map_id = id
        } else if(file_type == '3d_metalness') {
          this.styles[style_index].three_d_detail_layer.metalness_map_url = file_url
          this.styles[style_index].three_d_detail_layer.metalness_map_id = id
        } else if(file_type == '3d_ao') {
          this.styles[style_index].three_d_detail_layer.ao_map_url = file_url
          this.styles[style_index].three_d_detail_layer.ao_map_id = id
        } else if(file_type == '3d_alpha') {
          this.styles[style_index].three_d_detail_layer.alpha_map_url = file_url
          this.styles[style_index].three_d_detail_layer.alpha_map_id = id
        }
  
        this.$bvModal.hide('secondDetailLayerModal');
      },
      getDetailLayerObject() {
        return {
          front_layer_id: null, front_layer_url: null, back_layer_id: null, back_layer_url: null,
          composition: getCompositionsOptions({only_options:'multiply'})
        }
      },
      get3DDetailLayerObject() {
        return {
          three_d_model_id: null, 
          three_d_model_url: null, 
          three_d_texture_id: null, 
          three_d_texture_url: null,
          roughness_map_id: null,
          roughness_map_url: null,
          metalness_map_id: null,
          metalness_map_url: null,
          ao_map_id: null,
          ao_map_url: null,
          alpha_map_id: null,
          alpha_map_url: null
        }
      },

      get3DProperties() {
        return {
          roughness: 0.55,
          metalness: 0,
          insideMaterialColor: '#dedede', 
          normalScaleX: 0.8, 
          normalScaleY: 0.8, 
          reflectivity: 0.35,
          sheen: 2,
          sheenColor: '#b3b3b3',
          sheenRoughness: 0.8,
          textureTiling: true,
          tileX: 9,
          tileY: 9,
        }
      },
       async getDetailLayersFromStyle(style) {
        const {id: product_style_id, detail_layers, back_enabled = true } = style
        let payload =  detail_layers.filter((detail_layer) => {
          const { front_layer_id, back_layer_id } = detail_layer
          return front_layer_id || back_layer_id
        }).map((filtered_detail_layer, filteredDetailLayerIndex) => {
          const { front_layer_id, back_layer_id, composition: {code: composition} } = filtered_detail_layer
          return {
            type : '2d_detail_layer', front_layer_id, back_layer_id, composition, product_style_id, sort_order: filteredDetailLayerIndex
          }
        })
  
         if(this.is_3d_product) {
           const { three_d_detail_layer } = style
           payload.push({
             type : '3d_model', front_layer_id : three_d_detail_layer.three_d_model_id, back_layer_id : null,
             composition :null, product_style_id, sort_order: 0
           })
  
           payload.push({
             type : '3d_texture', front_layer_id : three_d_detail_layer.three_d_texture_id, back_layer_id : null,
             composition :null, product_style_id, sort_order: 0
           })
  
           // Add optional texture maps if they exist
           if (three_d_detail_layer.roughness_map_url) {
             payload.push({
               type : '3d_roughness', front_layer_id : three_d_detail_layer.roughness_map_id, back_layer_id : null,
               composition :null, product_style_id, sort_order: 0, channel_value: three_d_detail_layer.roughness
             })
           }
  
           if (three_d_detail_layer.metalness_map_url) {
             payload.push({
               type : '3d_metalness', front_layer_id : three_d_detail_layer.metalness_map_id, back_layer_id : null,
               composition :null, product_style_id, sort_order: 0, channel_value: three_d_detail_layer.metalness
             })
           }
  
           if (three_d_detail_layer.ao_map_url) {
             payload.push({
               type : '3d_ao', front_layer_id : three_d_detail_layer.ao_map_id, back_layer_id : null,
               composition :null, product_style_id, sort_order: 0
             })
           }
  
            if (three_d_detail_layer.alpha_map_url) {
             payload.push({
               type : '3d_alpha', front_layer_id : three_d_detail_layer.alpha_map_id, back_layer_id : null,
               composition :null, product_style_id, sort_order: 0
             })
           }
         }
  
        return payload
      },

      get3DPropertiesFromStyle(style) {
        const { three_d_properties } = style;
        console.log(three_d_properties);
        if(this.is_3d_product) {
          return three_d_properties;
        }
      },
      swapDetailLayer(action, style_index, detail_layer_index) {
        const swap_with_index = action == 'up' ? detail_layer_index - 1 : detail_layer_index + 1
        let detail_layers = JSON.parse(JSON.stringify(this.styles[style_index].detail_layers));
        if(action == 'up') {
          this.styles[style_index].detail_layers.splice(swap_with_index, 2, detail_layers[detail_layer_index], detail_layers[swap_with_index])
        } else {
          this.styles[style_index].detail_layers.splice(detail_layer_index, 2, detail_layers[swap_with_index], detail_layers[detail_layer_index])
        }
      },
      async formatStyleDetailLayers(style) {
        let { detail_layers } = style
        let style_existing_detail_layers = []
        if(detail_layers.length > 0) {
          detail_layers.forEach(detail_layer => {
            if(detail_layer.type == '2d_detail_layer') {
              const {front_layer_id, front_detail_layer, back_layer_id, back_detail_layer, composition } = detail_layer
              let layer_data = {
                front_layer_id, front_layer_url: null, back_layer_id, back_layer_url: null, composition
              }
              if(front_detail_layer) {
                layer_data.front_layer_url = front_detail_layer.file_url
              }
              if(back_detail_layer) {
                layer_data.back_layer_url = back_detail_layer.file_url
              }
              if(composition) {
                layer_data.composition = getCompositionsOptions({only_options: composition})
              }
              style_existing_detail_layers.push(layer_data)
            }
           })
          return style_existing_detail_layers
        } else {
          return []
        }
      },
      async format3DStyleDetailLayers(style) {
        let { detail_layers } = style
        let style_existing_detail_layer = {
          three_d_model_id: null, 
          three_d_model_url: null, 
          three_d_texture_id: null, 
          three_d_texture_url: null,
          roughness_map_id: null,
          roughness_map_url: null,
          metalness_map_id: null,
          metalness_map_url: null,
          ao_map_id: null,
          ao_map_url: null,
          alpha_map_id: null,
          alpha_map_url: null,
          materialColor: '#dedede',
          sheenColor: '#b3b3b3'
        }
        if(detail_layers.length > 0) {
          detail_layers.forEach(detail_layer => {
            const {type, front_detail_layer } = detail_layer
            if(type == '3d_model') {
              style_existing_detail_layer.three_d_model_id = front_detail_layer.id
              style_existing_detail_layer.three_d_model_url = front_detail_layer.file_url
            } else if(type == '3d_texture')  {
              style_existing_detail_layer.three_d_texture_id = front_detail_layer.id
              style_existing_detail_layer.three_d_texture_url = front_detail_layer.file_url
            } else if(type == '3d_roughness')  {
              style_existing_detail_layer.roughness_map_id = front_detail_layer.id
              style_existing_detail_layer.roughness_map_url = front_detail_layer.file_url
              style_existing_detail_layer.roughness = detail_layer.channel_values
            } else if(type == '3d_metalness')  {
              style_existing_detail_layer.metalness_map_id = front_detail_layer.id
              style_existing_detail_layer.metalness_map_url = front_detail_layer.file_url
              style_existing_detail_layer.metalness = detail_layer.channel_values
            } else if(type == '3d_ao')  {
              style_existing_detail_layer.ao_map_id = front_detail_layer.id
              style_existing_detail_layer.ao_map_url = front_detail_layer.file_url
            } else if(type == '3d_alpha')  {
              style_existing_detail_layer.alpha_map_id = front_detail_layer.id
              style_existing_detail_layer.alpha_map_url = front_detail_layer.file_url
            }
          })
         }
        return style_existing_detail_layer
      },

     format3DProperties(style) {

        let { three_d_properties } = style;
        let style_existing_three_d_properties = {
          roughness: 0.55,
          metalness: 0,
          insideMaterialColor: '#dedede', 
          normalScaleX: 0.8, 
          normalScaleY: 0.8, 
          reflectivity: 0.35,
          sheen: 2,
          sheenColor: '#b3b3b3',
          sheenRoughness: 0.8,
          textureTiling: true,
          tileX: 9,
          tileY: 9,
        }

        if(three_d_properties) {
          style_existing_three_d_properties.roughness = three_d_properties.roughness;
          style_existing_three_d_properties.metalness = three_d_properties.metalness;
          style_existing_three_d_properties.insideMaterialColor = three_d_properties.insideMaterialColor;
          style_existing_three_d_properties.normalScaleX = three_d_properties.normalScaleX;
          style_existing_three_d_properties.normalScaleY = three_d_properties.normalScaleY;
          style_existing_three_d_properties.reflectivity = three_d_properties.reflectivity;
          style_existing_three_d_properties.sheen = three_d_properties.sheen;
          style_existing_three_d_properties.sheenColor = three_d_properties.sheenColor;
          style_existing_three_d_properties.sheenRoughness = three_d_properties.sheenRoughness;
          style_existing_three_d_properties.textureTiling = three_d_properties.textureTiling;
          style_existing_three_d_properties.tileX = three_d_properties.tileX;
          style_existing_three_d_properties.tileY = three_d_properties.tileY;
        }

        return style_existing_three_d_properties;
      },

      getStyleDefaultObject(updated_props = {}) {
        const default_obj = { 
          id:0, 
          tab_title: 'Style', 
          back_enabled: true, 
          selected_container: null, 
          default_style: false, 
          is_default_design: false, 
          checked_index:-1,
          designs: [], 
          detail_layers: [this.getDetailLayerObject()], 
          three_d_detail_layer: this.get3DDetailLayerObject(), 
          fixed_logos: [
            { x_axis: '', y_axis: '', rotation: '', logo_url: '', width: '', height: '', file_id: '', side: '' }
          ],
          three_d_properties: this.get3DProperties()
        }
        if('detail_layers' in updated_props && updated_props.detail_layers.length == 0) {
        updated_props.detail_layers.push(this.getDetailLayerObject())
      }
      updated_props = JSON.parse(JSON.stringify(updated_props))
      return {...default_obj, ...updated_props}
    },
    addStyleFixedLogo(selectedLogo){
      Vue.set(this.styles[this.style_index], 'style_icon_url', selectedLogo.file_url);
      Vue.set(this.styles[this.style_index], 'style_icon_id', selectedLogo.id);
      if(this.errors.first(`fixed_logo_image_1${this.style_index}`)) {
        for (let i = 0; i < this.errors.items.length; i++) {
          if (this.errors.items[i].field === `fixed_logo_image_1${this.style_index}`) {
            this.errors.items.splice(i, 1);
          }
        }
      }
      this.show_style_icon_url = true;
      this.$bvModal.hide('setStyleFixedLogo');
      this.$forceUpdate();
    },
    setStyleFixedLogo(styleIndex){
      this.style_index = styleIndex;
      // this.fixed_logo_index = fixedLogoIndex;
      this.$bvModal.show('setStyleFixedLogo');
    },
    removeStyleFixedLogo(styleIndex){
      Vue.set(this.styles[styleIndex], 'style_icon_url', '');
      Vue.set(this.styles[styleIndex], 'style_icon_id', '');
      if(this.errors.first(`fixed_logo_image_1${this.style_index}`)) {
        for (let i = 0; i < this.errors.items.length; i++) {
          if (this.errors.items[i].field === `fixed_logo_image_1${this.style_index}`) {
            this.errors.items.splice(i, 1);
          }
        }
      }
      this.show_style_icon_url = false;
      this.$forceUpdate();
    },
    getLastFileName(url) {
      // Use JavaScript string manipulation to extract the last part after the last '/'
      const parts = url.split("/");
      return parts[parts.length - 1];
    },
  }
}
</script>
<style lang="scss" scoped>
.add_field_btn{
  width: 125px;
  .float-right{
    line-height: 0;
  }
}
.btn-add-fields.add-style-btn{
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: auto;
  height: auto;
  border-radius: 30px;
  font-size: 14px;
  padding: 0.5rem 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-transform: capitalize;
  z-index: 2;
  span{
    font-size: 22px;
    font-weight: 600;
  }
  &:before{
    border-radius: 30px;
  }
}

.add-product-holder .btn-primary{
  background: #009FE3;
  border-color: #009FE3;
  font-size: 20px;
  padding: 0.5rem 2rem;
}

.btn-primary.light{
  background: #c8e4f3 !important;
  border-color: #c8e4f3 !important;
  color: #009FE3 !important;
}

.remove-icon{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  height: 20px;
  width: 20px;
  background: #C80000;
  color: #fff;
  border-radius: 99px;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: 0.2s all ease;
  z-index: 30;
}

.remove-icon:hover{
  background: #ff0000;
}
</style>